export default "__VITE_ASSET__C$3cO8IQ__"